import { render, staticRenderFns } from "./scenario-viewer.vue?vue&type=template&id=22050494&scoped=true"
import script from "./scenario-viewer.vue?vue&type=script&lang=js"
export * from "./scenario-viewer.vue?vue&type=script&lang=js"
import style0 from "./scenario-viewer.vue?vue&type=style&index=0&id=22050494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22050494",
  null
  
)

export default component.exports